import { CheckOutlined, GlobalOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { useState } from "react";
import { useI18n } from "../i18n";

/**
 * The language picker.
 *
 * It sits in the topbar next to the user chip rather than inside a settings
 * page: an admin working in a second language needs it on the first screen
 * they land on, not after finding their way to a preferences screen. Each
 * language is written in its own script, so it is legible whichever one is
 * currently active.
 */
export const LanguageSwitcher = ({ variant = "chip" }: { variant?: "chip" | "standalone" }) => {
    const { locale, current, locales, setLocale, t } = useI18n();
    const [open, setOpen] = useState(false);

    const overlay = (
        <div className="user-menu lang-menu">
            <div className="lang-menu__label eyebrow">{t("language.label")}</div>
            {locales.map(entry => (
                <button
                    key={entry.code}
                    type="button"
                    lang={entry.tag}
                    className={`user-menu__item${entry.code === locale ? " is-active" : ""}`}
                    aria-current={entry.code === locale ? "true" : undefined}
                    onClick={() => {
                        setOpen(false);
                        setLocale(entry.code);
                    }}
                >
                    <span className="lang-menu__name">{entry.label}</span>
                    {entry.code === locale ? <CheckOutlined className="lang-menu__tick" /> : null}
                </button>
            ))}
        </div>
    );

    return (
        <Dropdown
            overlay={overlay}
            trigger={["click"]}
            placement="bottomRight"
            visible={open}
            onVisibleChange={setOpen}
        >
            <button
                type="button"
                className={`lang-chip${variant === "standalone" ? " lang-chip--standalone" : ""}`}
                aria-label={t("language.label")}
                title={`${t("language.label")}: ${current.label}`}
            >
                <GlobalOutlined />
                <span className="lang-chip__code">{current.short}</span>
            </button>
        </Dropdown>
    );
};
